import { render, staticRenderFns } from "./MultiselectItemStorages.vue?vue&type=template&id=28a5d560&scoped=true"
import script from "./MultiselectItemStorages.vue?vue&type=script&lang=js"
export * from "./MultiselectItemStorages.vue?vue&type=script&lang=js"
import style0 from "./MultiselectItemStorages.vue?vue&type=style&index=0&id=28a5d560&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a5d560",
  null
  
)

export default component.exports